module.exports = __webpack_public_path__ + "img/add-icon-gray.5f325de5.svg";